import {
  SUPPORT_FETCH_REQUEST,
  SUPPORT_FETCH_REQUEST_SUCCESS,
  SUPPORT_FETCH_REQUEST_FAILURE,
  SUPPORT_CLEAN_REQUEST,
  SUPPORT_ADD_REQUEST,
  SUPPORT_ADD_REQUEST_SUCCESS,
  SUPPORT_ADD_REQUEST_FAILURE,
  SUPPORT_STAFF_FETCH_REQUEST,
  SUPPORT_STAFF_FETCH_REQUEST_SUCCESS,
  SUPPORT_STAFF_FETCH_REQUEST_FAILURE,
  SUPPORT_STAFF_CLEAN_REQUEST,
  SUPPORT_PRIORITY_FETCH_REQUEST,
  SUPPORT_PRIORITY_FETCH_REQUEST_SUCCESS,
  SUPPORT_PRIORITY_FETCH_REQUEST_FAILURE,
  SUPPORT_PRIORITY_CLEAN_REQUEST,
  SUPPORT_REPORTED_TO_FETCH_REQUEST,
  SUPPORT_REPORTED_TO_FETCH_REQUEST_SUCCESS,
  SUPPORT_REPORTED_TO_FETCH_REQUEST_FAILURE,
  SUPPORT_REPORTED_TO_CLEAN_REQUEST,
  SUPPORT_ASSIGN_TO_FETCH_REQUEST,
  SUPPORT_ASSIGN_TO_FETCH_REQUEST_SUCCESS,
  SUPPORT_ASSIGN_TO_FETCH_REQUEST_FAILURE,
  SUPPORT_ASSIGN_TO_CLEAN_REQUEST,
  SUPPORT_EDIT_FETCH_REQUEST,
  SUPPORT_EDIT_FETCH_REQUEST_SUCCESS,
  SUPPORT_EDIT_FETCH_REQUEST_FAILURE,
  SUPPORT_EDIT_CLEAN_REQUEST,
  SUPPORT_UPDATE_FETCH_REQUEST,
  SUPPORT_UPDATE_FETCH_REQUEST_SUCCESS,
  SUPPORT_UPDATE_FETCH_REQUEST_FAILURE,
  SUPPORT_UPDATE_CLEAN_REQUEST,
  SUPPORT_TICKET_TYPE_CLEAN_REQUEST,
  SUPPORT_TICKET_TYPE_FETCH_REQUEST_FAILURE,
  SUPPORT_TICKET_TYPE_FETCH_REQUEST_SUCCESS,
  SUPPORT_TICKET_TYPE_FETCH_REQUEST,
  SUPPORT_DETAILS_FETCH_REQUEST,
  SUPPORT_DETAILS_FETCH_REQUEST_SUCCESS,
  SUPPORT_DETAILS_FETCH_REQUEST_FAILURE,
  SUPPORT_DETAILS_CLEAN_REQUEST,
  SUPPORT_TICKET_STATUS_FETCH_REQUEST,
  SUPPORT_TICKET_STATUS_CLEAN_REQUEST,
  SUPPORT_TICKET_STATUS_FETCH_REQUEST_FAILURE,
  SUPPORT_TICKET_STATUS_FETCH_REQUEST_SUCCESS,
  SUPPORT_TICKET_STATUS_UPDATE_CLEAN_REQUEST,
  SUPPORT_TICKET_STATUS_UPDATE_REQUEST_FAILURE,
  SUPPORT_TICKET_STATUS_UPDATE_REQUEST_SUCCESS,
  SUPPORT_TICKET_STATUS_UPDATE_REQUEST,
  EDIT_SUPPORT_TICKET_CLEAN_REQUEST,
  EDIT_SUPPORT_TICKET_REQUEST_FAILURE,
  EDIT_SUPPORT_TICKET_REQUEST_SUCCESS,
  EDIT_SUPPORT_TICKET_REQUEST,
  SUPPORT_TICKET_SUMMARY_CLEAN_REQUEST,
  SUPPORT_TICKET_SUMMARY_REQUEST_FAILURE,
  SUPPORT_TICKET_SUMMARY_REQUEST_SUCCESS,
  SUPPORT_TICKET_SUMMARY_REQUEST,
  SUPPORT_MERCHANT_LIST_FETCH_REQUEST,
  SUPPORT_MERCHANT_LIST_FETCH_REQUEST_SUCCESS,
  SUPPORT_MERCHANT_LIST_FETCH_REQUEST_FAILURE,
  SUPPORT_MERCHANT_LIST_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},

  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
    nextCursorId: null,
  },
};

const INITIAL_STATE_STAFF = {
  payload: [],
  loading: false,
  errors: {},

  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
    nextCursorId: null,
  },
};

const UPDATE_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

const PRIORITY_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const TICKET_TYPE_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const TICKET_STATUS_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const EDIT_TICKET_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const MERCHANT_LIST_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const REPORTEDTO_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const ASSIGNTO_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

const SUPPORT_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};
const SUPPORT_SUMMARY_INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

export const supportPriorityReducer = (state, action) => {
  state = state || PRIORITY_INITIAL_STATE;

  switch (action.type) {
    case SUPPORT_PRIORITY_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_PRIORITY_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SUPPORT_PRIORITY_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_PRIORITY_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};
export const supportTicketTypeReducer = (state, action) => {
  state = state || TICKET_TYPE_INITIAL_STATE;

  switch (action.type) {
    case SUPPORT_TICKET_TYPE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_TICKET_TYPE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SUPPORT_TICKET_TYPE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_TICKET_TYPE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export const supportReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case SUPPORT_FETCH_REQUEST:
    case SUPPORT_ADD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_FETCH_REQUEST_SUCCESS:
    case SUPPORT_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          nextCursorId: action.data.nextCursorId,
          showSizeChanger: true,
        },
      });

    case SUPPORT_FETCH_REQUEST_FAILURE:
    case SUPPORT_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        CRUDErrors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

// support staff starts

export const supportStaffReducer = (state, action) => {
  state = state || INITIAL_STATE_STAFF;

  switch (action.type) {
    case SUPPORT_STAFF_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_STAFF_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case SUPPORT_STAFF_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_STAFF_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        CRUDErrors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

// support staff ends

export const supportMerchantListReducer = (state, action) => {
  state = state || MERCHANT_LIST_INITIAL_STATE;

  switch (action.type) {
    case SUPPORT_MERCHANT_LIST_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_MERCHANT_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SUPPORT_MERCHANT_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_MERCHANT_LIST_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export const supportReportToReducer = (state, action) => {
  state = state || REPORTEDTO_INITIAL_STATE;

  switch (action.type) {
    case SUPPORT_REPORTED_TO_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_REPORTED_TO_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SUPPORT_REPORTED_TO_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_REPORTED_TO_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export const supportAssignToReducer = (state, action) => {
  state = state || ASSIGNTO_INITIAL_STATE;

  switch (action.type) {
    case SUPPORT_ASSIGN_TO_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_ASSIGN_TO_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SUPPORT_ASSIGN_TO_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_ASSIGN_TO_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

// SUPPORT EDIT START

export const supportEditReducer = (state, action) => {
  state = state || SUPPORT_INITIAL_STATE;

  switch (action.type) {
    case SUPPORT_EDIT_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_EDIT_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SUPPORT_EDIT_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_EDIT_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

// SUPPORT EDIT END

// support update start

export const supportUpdateReducer = (state, action) => {
  state = state || UPDATE_INITIAL_STATE;

  switch (action.type) {
    case SUPPORT_UPDATE_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_UPDATE_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SUPPORT_UPDATE_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_UPDATE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

// support update end

export const supportDetailsReducer = (state, action) => {
  state = state || SUPPORT_INITIAL_STATE;

  switch (action.type) {
    case SUPPORT_DETAILS_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_DETAILS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SUPPORT_DETAILS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_DETAILS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export const supportTicketStatusReducer = (state, action) => {
  state = state || TICKET_STATUS_INITIAL_STATE;

  switch (action.type) {
    case SUPPORT_TICKET_STATUS_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_TICKET_STATUS_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SUPPORT_TICKET_STATUS_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_TICKET_STATUS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};
export const updateSupportTicketStatusReducer = (state, action) => {
  state = state || TICKET_STATUS_INITIAL_STATE;

  switch (action.type) {
    case SUPPORT_TICKET_STATUS_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_TICKET_STATUS_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SUPPORT_TICKET_STATUS_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_TICKET_STATUS_UPDATE_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};
export const editSupportTicketReducer = (state, action) => {
  state = state || EDIT_TICKET_INITIAL_STATE;

  switch (action.type) {
    case EDIT_SUPPORT_TICKET_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case EDIT_SUPPORT_TICKET_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case EDIT_SUPPORT_TICKET_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case EDIT_SUPPORT_TICKET_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};
export const supportTicketSummaryReducer = (state, action) => {
  state = state || SUPPORT_SUMMARY_INITIAL_STATE;

  switch (action.type) {
    case SUPPORT_TICKET_SUMMARY_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case SUPPORT_TICKET_SUMMARY_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case SUPPORT_TICKET_SUMMARY_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case SUPPORT_TICKET_SUMMARY_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};
